module.exports = __webpack_public_path__ + "assets/img/doctor-head-backleft.3f1e01a1.png";